/* heading.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import React from "react";
import theme from "../theme";
var _35 = "._1di61emw:active{background-color:rgba(203,166,247,.6)}";
var _34 = "._1hvw1o36:focus{outline-width:medium}";
var _33 = "._49pcglyw:focus{outline-style:none}";
var _32 = "._nt751r31:focus{outline-color:currentColor}";
var _31 = "._d0altlke:hover{cursor:pointer}";
var _30 = "._30l35y2n:hover{color:#cdd6f4}";
var _29 = "._irr31wye:hover{background-color:rgba(203,166,247,.4)}";
var _28 = "._11q71j28{background:transparent}";
var _27 = "._19itglyw{border:none}";
var _26 = "._2rkoyh40{border-radius:2px}";
var _25 = "._v564111k{transition:background .3s,color .3s}";
var _24 = "._syazryvq{color:rgba(205,214,244,.8)}";
var _23 = "._1wyb1skh{font-size:11px}";
var _22 = "._18u0ftgi{margin-left:8px}";
var _21 = "._2hwx14id{margin-right:-10px}";
var _20 = "._19pkyjp0{margin-top:-6px}";
var _19 = "._19bv19bv{padding-left:10px}";
var _18 = "._n3tdi2wt{padding-bottom:6px}";
var _17 = "._u5f319bv{padding-right:10px}";
var _16 = "._ca0qi2wt{padding-top:6px}";
var _15 = "._1e0c1txw{display:flex}";
var _14 = "._16jlkb7n{flex-grow:1}";
var _13 = "._1p1dangw{text-transform:uppercase}";
var _12 = "._1wybw1gv{font-size:13px}";
var _11 = "._1dyzt94y{letter-spacing:1px}";
var _10 = "._k48p1nn1{font-weight:400}";
var _9 = "._18u0idpf{margin-left:0}";
var _8 = "._otyridpf{margin-bottom:0}";
var _7 = "._2hwxidpf{margin-right:0}";
var _6 = "._19pkidpf{margin-top:0}";
var _5 = "._19bvidpf{padding-left:0}";
var _4 = "._n3tdidpf{padding-bottom:0}";
var _3 = "._u5f3idpf{padding-right:0}";
var _2 = "._ca0qidpf{padding-top:0}";
var _ = "._syaz1ds0{color:#b4befe}";
var headingStyles = null;
var Heading = function Heading(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14]), /*#__PURE__*/React.createElement("h2", {
    className: ax(["_syaz1ds0 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1dyzt94y _1wybw1gv _1p1dangw _16jlkb7n"])
  }, children));
};
var headingWithButtonStyles = null;
var HeadingWithButton = function HeadingWithButton(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_15]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw"])
  }, children));
};
var headingButtonStyles = null;
var HeadingButton = function HeadingButton(_ref3) {
  var children = _ref3.children,
    onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_16, _17, _18, _19, _20, _21, _8, _22, _10, _11, _23, _24, _13, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35]), /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: ax(["_ca0qi2wt _u5f319bv _n3tdi2wt _19bv19bv _19pkyjp0 _2hwx14id _otyridpf _18u0ftgi _k48p1nn1 _1dyzt94y _1wyb1skh _syazryvq _1p1dangw _v564111k _2rkoyh40 _19itglyw _11q71j28 _irr31wye _30l35y2n _d0altlke _nt751r31 _49pcglyw _1hvw1o36 _1di61emw"])
  }, children));
};
export { Heading, HeadingWithButton, HeadingButton };